import { Dayjs } from 'dayjs';
import { DateFormat } from 'types';

export const parseDayjsDateIntoString: (date: Dayjs, format?: DateFormat) => string = (
    date,
    format = 'DD/MM/YYYY',
) => date.format(format);
